import { inject, Injectable } from '@angular/core';
import { Observable, ReplaySubject, switchMap, tap } from 'rxjs';
import { CucmE164TransformationRule } from '../models/generated/ziroModels';
import { HttpClient } from '@angular/common/http';

export interface NormalizedTranslationRule {
  fromPrefix: string;
  fromXCount: number;
  toPrefix?: string;
  description: string;
}

@Injectable()
export class MicrosoftCucmE164TransformationRulesContext {
  protected _http = inject(HttpClient);

  private _stateSource = new ReplaySubject<CucmE164TransformationRule[]>(1);
  state$ = this._stateSource.asObservable();
  private _baseUrl = '';

  setBaseUrl(tenantId: number, exportId: string): void {
    this._baseUrl = `/services/microsoft/migrations/tenants/${tenantId}/exports/cisco/${exportId}/number-report/transformation-rules`;
  }

  private _get(): Observable<CucmE164TransformationRule[]> {
    return this._http.get<CucmE164TransformationRule[]>(this._baseUrl);
  }

  put(body: CucmE164TransformationRule[]): Observable<CucmE164TransformationRule[]> {
    return this._http.put<CucmE164TransformationRule[]>(this._baseUrl, body).pipe(switchMap(() => this.refresh()));
  }

  refresh(): Observable<CucmE164TransformationRule[]> {
    return this._get().pipe(
      tap((e164Rules: CucmE164TransformationRule[]) => {
        this._stateSource.next(e164Rules);
      }),
    );
  }
}
